import _ from 'lodash';

import { PendingChangesActionType } from 'constants/pendingChanges';

// A first fee override (FH-3852) arrives as an EntityAdded change but carries the superseded base amount as its old
// value, so it reads as an edit of the logical fee rather than a brand-new row. Render such a change as old → new
// with the Modified badge; a genuinely new row keeps a null old value and still renders as Added.
export const getCardDisplayMode = ({ changeType, oldValue }) => {
  const isAddedWithPriorValue = changeType === PendingChangesActionType.ADDED && !_.isNil(oldValue);

  return {
    showAsAdded: changeType === PendingChangesActionType.ADDED && !isAddedWithPriorValue,
    effectiveChangeType: isAddedWithPriorValue ? PendingChangesActionType.MODIFIED : changeType,
  };
};
